<template>
	<div>
		<div class="row mt-4 pl-4 pr-4" >
			<div class="col-md col-12 mt-2 pl-3 pr-3 text-center">
				<div class="border border-secondary rounded row pt-4 pb-4 hoverable" style="height:125px" @click="referenceWorkOrder = 'New Work Order'" :class="{'selected' : referenceWorkOrder == 'New Work Order'}">
					<div class="col-4 mt-auto mb-auto">
						<i class="fa fa-plus-square fa-5x"></i>
					</div>
					<div class="col-8 mt-auto mb-auto text-left">
						<h3>New Work Order</h3>
						<span style="font-size:12px">Bikin Work Order Baru</span>
						<br>
					</div>
				</div>
			</div>
			<div class="col-md col-12 mt-2 pl-3 pr-3 text-center">
				<div class="border border-secondary rounded row pt-4 pb-4 hoverable" style="height:125px" @click="referenceWorkOrder = 'Customer Quotation'" :class="{'selected' : referenceWorkOrder == 'Customer Quotation'}">
					<div class="col-4 mt-auto mb-auto">
						<i class="fa fa-sticky-note fa-5x"></i>
					</div>
					<div class="col-8 mt-auto mb-auto text-left">
						<h3>Customer Quotation</h3>
						<span style="font-size:12px">Customer telah membawa quotation kepada bengkel</span>
					</div>
					
				</div>
			</div>
			<!-- <div class="col-md col-12 mt-2 pl-3 pr-3 text-center" v-if="!allowMerge">
				<div class="border border-secondary rounded row pt-4 pb-4 hoverable" style="height:125px" @click="referenceWorkOrder = 'Complain Work Order'" :class="{'selected' : referenceWorkOrder == 'Complain Work Order'}">
					<div class="col-4 mt-auto mb-auto">
						<i class="fa fa-users fa-5x"></i>
					</div>
					<div class="col-8 mt-auto mb-auto text-left">
						<h3>Complain Work Order</h3>
						<span style="font-size:12px">Customer mengaju pengaduan perkerjaan Work Order</span>
					</div>
				</div>
			</div> -->
			<div class="col-md col-12 mt-2 pl-3 pr-3 text-center" v-if="allowMerge">
				<div class="border border-secondary rounded row pt-4 pb-4 hoverable" style="height:125px" @click="referenceWorkOrder = 'Merge Workorder'" :class="{'selected' : referenceWorkOrder == 'Merge Workorder'}">
					<div class="col-4 mt-auto mb-auto">
						<i class="fa fa-users fa-5x"></i>
					</div>
					<div class="col-8 mt-auto mb-auto text-left">
						<h3>Merge Workorder</h3>
						<span style="font-size:12px">Gabungkan Kondisi Mobil dengan WO yang sudah di proses</span>
					</div>
				</div>
			</div>
		</div>

		<div class="row mt-4 mb-4 " v-if="referenceWorkOrder != 'Merge Workorder'">
			<div class="col-12 mt-2">
				<h4>Pilih Tipe Servis Work Order</h4>
			</div>
			<div class="col-md col-12 mt-2 pl-3 pr-3 text-center">
				<div class="border border-secondary rounded row pt-4 pb-4 hoverable" style="height:125px" @click="data.serviceType = 'Mobil Menginap'" :class="{'selected' : data.serviceType == 'Mobil Menginap'}">
					<div class="col-4 mt-auto mb-auto">
						<!-- <i class="fa fa-plus-square fa-5x"></i> -->
						<img src="/img/newIcon/mobil-menginap.svg" style="height:70px" />
					</div>
					<div class="col-8 mt-auto mb-auto text-left">
						<h3>Mobil Menginap</h3>
						<span style="font-size:12px">Mobil Berada Di Bengkel</span>
						<br>
					</div>
				</div>
			</div>
			<div class="col-md col-12 mt-2 pl-3 pr-3 text-center">
				<div class="border border-secondary rounded row pt-4 pb-4 hoverable" style="height:125px" @click="data.serviceType = 'Rawat Jalan'" :class="{'selected' : data.serviceType == 'Rawat Jalan'}">
					<div class="col-4 mt-auto mb-auto">
						<img src="/img/newIcon/rawat-jalan.svg" style="height:70px" />
					</div>
					<div class="col-8 mt-auto mb-auto text-left">
						<h3>Rawat Jalan</h3>
						<span style="font-size:12px">Mobil Berada Diluar Bengkel</span>
					</div>
					
				</div>
			</div>
			<!-- <div class="col-md col-12 mt-2 pl-3 pr-3 text-center" v-if="!(referenceWorkOrder == 'Complain Work Order')">
				<div class="border border-secondary rounded row pt-4 pb-4 hoverable" style="height:125px" @click="data.serviceType = 'Process Mobil'" :class="{'selected' : data.serviceType == 'Process Mobil'}">
					<div class="col-4 mt-auto mb-auto">
						<img src="/img/newIcon/process-mobil.svg" style="height:70px" />
					</div>
					<div class="col-8 mt-auto mb-auto text-left">
						<h3>Process Mobil</h3>
						<span style="font-size:12px">Sparepart Mobil Sedang Di Process</span>
					</div>
				</div>
			</div> -->
			<div class="col-md col-12 mt-2 pl-3 pr-3 text-center" v-if="!(referenceWorkOrder == 'Complain Work Order')">
				<div class="border border-secondary rounded row pt-4 pb-4 hoverable" style="height:125px" @click="data.serviceType = 'Beli Sparepart'" :class="{'selected' : data.serviceType == 'Beli Sparepart'}">
					<div class="col-4 mt-auto mb-auto">
						<!-- <img src="/img/newIcon/process-mobil.svg" style="height:70px" /> -->
						<i class="fa fa-dollar-sign fa-4x"></i>
					</div>
					<div class="col-8 mt-auto mb-auto text-left">
						<h3>Parts Only</h3>
						<span style="font-size:12px">Hanya Beli Sparepart Mobil</span>
					</div>
				</div>
			</div>
		</div>


		<div v-if="skip" class="mt-3">
			<h5>Deskripsi Mobil : {{data.customer_car.registration}}</h5>

			<h5 style="color:red">{{processMobilList.length > 0 ? 'Sudah ada workorder dengan nomor polisi yang sama. Mohon klik Merge Workorder untuk mengecek work order yang sedang berlanjut' : ''}}</h5>
		</div>


		<panel class="border border-secondary rounded mt-4 mb-4" :noButton="true" v-if="referenceWorkOrder == 'Customer Quotation'">
			<template slot="header">
				<h5>Customer Quotation</h5>
			</template>

			<b-form>
				<b-form-row>
					<b-form-group label="Pilih Referensi Customer Quotation" class="col-12">
						<Multiselect
							class="mt-1"
							:options="quotationList"
							label="name"
							placeholder=""
							v-model="chosenData"
						/>
					</b-form-group>
				</b-form-row>
			</b-form>
		</panel>
		
		<page1WorkOrder 
			v-if="referenceWorkOrder == 'New Work Order' || referenceWorkOrder == 'Customer Quotation'"
			:data="data"
			@nextPage="nextPage"
			:customerList="customerList"
		/>

		<!-- <div v-if="referenceWorkOrder == 'Complain Work Order'" class="mt-4  mb-4 text-center">
			<panel class="border border-secondary rounded mt-4 mb-4 text-left" :noButton="true">
				<template slot="header">
					<h5>Complain Work Order</h5>
				</template>

				<b-form>
					<b-form-row>
						<b-form-group label="Pilih Workorder yang akan di complain" class="col-12">
							<Multiselect
								class="mt-1"
								:options="complainList"
								label="name"
								placeholder=""
								v-model="chosenData"
							/>
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group label="Perkiraan Tanggal Selesai" class="col-12">
							<flat-pickr
								v-model="data.finishDate"
								:config="rangeConfig"
								placeholder="Pilih Tanggal"
							></flat-pickr>
						</b-form-group>
					</b-form-row>
				</b-form>
			</panel>
			<div class="row mt-3">
				<div class="offset-md-9 col-md-3 col-12">
					<button class=" mt-3 btn btn-primary w-100" type="button" @click="selectComplain">
						Complain Workorder
					</button>
				</div>
			</div>
		</div> -->

		<template v-if="referenceWorkOrder == 'Merge Workorder'">
			<div>
				<panel class="mt-4  mb-4 border border-secondary rounded" :noButton="true">
					<template slot="header">
						<h5>Gabungkan Work Order</h5>
					</template>
					<b-form>
						<b-form-row>
							<b-form-group :label="'Pilih Nomor WO'" class="col-12 ">
							<Multiselect
								class="mt-1"
								:options="processMobilList.map(x => x.form_code)"
								:custom-label="opt => `${opt} - ${processMobilList.find(x => x.form_code == opt).registration}`"
								v-model="chosenData"
							/>
							</b-form-group>
						</b-form-row>
						<b-form-row>
							<b-form-group label="Tipe Work Order" class="col-12 ">
							<Multiselect
								class="mt-1"
								:options="['Rawat Jalan' , 'Mobil Menginap']"
								v-model="serviceType"
							/>
							</b-form-group>
						</b-form-row>
					</b-form>
				</panel>

				<page1WorkOrder 
					:data="data"
					@nextPage="mergeWo"
					:customerList="customerList"
					:searchChassis="searchData"
				/>
			</div>
		</template>
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'

	import Datepicker from 'vuejs-datepicker'
	import moment from 'moment'
	import env from '@/env'

	import page1WorkOrder from './../children/page1_workOrder.vue'

	export default {
		data () {
			return {
				env,
				error : null,
				// new vars 
				showCustomerInput : false,
				showCustomerForm : false ,
				//end new vars
				
				options: this.$store.getters.getFilterOptions,
				vehicleList: [],
				searchData: null,
				quotationList: [],
				chosenData: null,
				serviceType : null,
				complainList : [],
				customerData: null,
				customerList: [],
				customerDisabled: false,
				fileErrorktp : '',
				referenceWorkOrder : 'New Work Order',
				complain : false,
				listInsuraceCarTypes : [],
				rangeConfig: {
					altInput: true,
					altInputClass: "form-control input flatpickr-input w-100",
					animate: !this.isRTL()
				},
				priceCondition : '-',
				cariMobil : false,
				complain : false,
				complainList : [],
				customerRequest : '',
				manualOptions : {
					brand : null,
					model : null,
					modelFull : null
				},
				processMobilList : [],
				searchChassis : ''
			}
		},
		props: ['page', 'data', 'skip' , 'allowMerge'],
		components: {
			Multiselect,
			Datepicker,
			page1WorkOrder
		},
		mounted() {

			this.$http.get('/api/v1/quotation?pagination=false')
			.then((resp) => {
				let data = resp.data.data

				for (var i = 0 ; i < data.length ; i++) {
					if(!data[i].work_order_created){
						data[i].name = `${data[i].form_code} (Nama : ${data[i].name})`
						this.quotationList.push(data[i])
					}
				}
			})
			.catch((err) => {
				console.log(err)
			})

			this.$http.get('/api/v1/masterData/customer?pagination=false')
			.then((resp) => {
				this.customerList = resp.data.data
				
				// for (var i = 0 ; i < this.customerList.length ; i++) {
				// 	this.customerList[i].view = `${this.customerList[i].phone_number} - ${this.customerList[i].name}`
				// }
			})
			.catch((err) => {
				console.log(err)
			})

			var urlBrand = `/api/v1/masterData/car/brand?pagination=false`
			var urlType =  `/api/v1/masterData/car/model?pagination=false`

			this.$http.get(urlBrand).then((resp) => {
				this.manualOptions.brand = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})

			this.$http.get(urlType).then((resp) => {
				this.manualOptions.modelFull = resp.data.data
				this.manualOptions.model = JSON.parse(JSON.stringify(this.manualOptions.modelFull))
			})
			.catch((err) => {
				console.log(err)
			})

			

			this.getComplainList()

			
			
		},
		watch: {
			customerRequest : function() {
				this.$emit('emitCQ' , this.customerRequest)
			},
			'data.customer_car.model' : function () {
				this.data.customer_car.car_id = this.data.customer_car.model.id
			},
			'data.customer_car.chassis_number' : function () {
				const result = this.data.customer_car.chassis_number.trim().toUpperCase();
				this.$nextTick(() => this.data.customer_car.chassis_number = result);
			},
			'data.customer_car.registration' : function () {
				if(this.allowMerge) {
					this.getProcessMobil()
				}

				const result = this.data.customer_car.registration.toUpperCase();
				this.$nextTick(() => this.data.customer_car.registration = result);
			},
			'data.customer_car.engine_number' : function () {
				const result = this.data.customer_car.engine_number.trim().toUpperCase();
				this.$nextTick(() => this.data.customer_car.engine_number = result);
			},
			'data.customer.ktp' : function () {
				const result = this.data.customer.ktp.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
				this.$nextTick(() => this.data.customer.ktp = result);
			},
			'data.customer_car.brand' : function () {
				// this.options.model = this.$store.getters.getSingleModelId(this.data.customer_car.brand.id)
				// console.log(this.manualOptions.modelFull , this.data.customer_car.brand)c
				console.log(this.data.customer_car.brand.id , this.manualOptions.modelFull)
				this.manualOptions.model = this.manualOptions.modelFull.filter(x => x.brand_id == this.data.customer_car.brand.id)
			},
			chosenData : function () {
				// console.log(this.quotationList , this.chosenData)
				// console.log(this.referenceWorkOrder , this.chosenData)
				if(this.referenceWorkOrder != 'Merge Workorder') {
					this.data.temp_code = this.data.form_code
					this.data.form_code = this.referenceWorkOrder == 'Customer Quotation' ? this.chosenData.form_code : null
				}
				else if(this.referenceWorkOrder == 'Merge Workorder') {
					console.log(this.processMobilList)
					this.$set(this , 'searchData' , this.processMobilList.find(x => x.form_code == this.chosenData) )
					// this.searchData = 

				}
			},
			customerData :function () {
					if(!this.customerData) {
						this.data.customer.name = ''
						this.data.customer.alias = ''
						delete this.data.customer.customer_id 
						this.data.customer.phone_number = ''
						this.data.customer.created_at = moment().format('MMMM, DD Y')
						this.data.customer.ktp = ''
						this.data.customer.email = ''
						this.data.customer.ktp_img = ''
						this.data.customer.address = ''
						this.data.customer_car.sim_img = ''
						this.data.customer.last_date = new moment().format('MMMM, DD Y')
						this.customerDisabled = false
						return;
					}

					this.data.customer.name = this.customerData.name
					this.data.customer.alias = this.customerData.alias
					this.data.customer.customer_id = this.customerData.id
					this.data.customer.email = this.customerData.email
					this.data.customer.phone_number = this.customerData.phone_number
					this.data.customer.created_at = moment(this.customerData.created_at).format('MMMM, DD Y')
					this.data.customer.ktp = this.customerData.ktp
					this.data.customer.address = this.customerData.address
					this.data.customer.ktp_img = this.customerData.ktp_img
					this.data.customer_car.sim_img = this.customerData.sim_img
					this.data.customer.last_date = this.customerData.last_date ? new moment(this.customerData.last_date).format('MMMM, DD Y') : new moment().format('MMMM, DD Y')
					this.customerDisabled = true
			},
			searchData : function () {
				if(!this.searchData) {
					this.cariMobil = false
					return;
				}
				console.log(this.searchData)

				this.cariMobil = true

				this.$http.get('/api/v1/workorder/chassis/fetch/' + this.searchData.chassis_number)
				.then((resp) => {
					let data = resp.data.data[0]
					console.log(data)
					if(data.name) {
						this.data.customer.name = data.name
						this.data.customer.customer_id = data.id
						this.data.customer.phone_number = data.phone_number
						this.data.customer.ktp = data.ktp
						this.data.customer.address = data.address
						this.data.customer.ktp_img = data.ktp_img
						this.data.customer.email = data.email
						this.data.customer.created_at = moment(data.created_at).format('MMMM, DD Y')
						this.data.customer.last_date = data.last_date ? new moment(data.last_date).format('MMMM, DD Y') : new moment().format('MMMM, DD Y')
					}
					
					this.data.customer_car.chassis_number = data.chassis_number
					this.data.customer_car.year = data.year
					this.data.customer_car.stnk_img = data.stnk_img
					this.data.customer_car.sim_img = data.sim_img
					this.data.customer_car.engine_number = data.engine_number
					this.data.customer_car.registration = data.registration
					this.data.customer_car.last_km = this.numberWithCommas(data.last_km)
					this.data.customer_car.car_id = data.car.id
					this.data.customer_car.brand = {
						id : data.car.brand_id,
						name: data.car.cb.name
					}
					// this.carType = data.car_type.toLowerCase()

					this.data.customer_car.colour = {
						id : data.color_id,
						name: data.color_name
					}

					this.data.customer_car.model = {
						brand_id : data.car.brand_id,
						brand_name: data.car.cb.name,
						id : data.car.id,
						name: data.car.name
					}
					this.showCustomerInput = true
					this.showCustomerForm = true
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		methods: {
			validateSize : function(data, type){
			
				var file = data.target.files[0];

				var size  = file.size / 1024 / 1024;

				if(size > 20)
				{
					this['fileError' + type] = "Limit Size Gambar 8 MB";
					return false;
				}

				let url = env.urlStart + "/api/v1/workorder/image"
				let formData = new FormData()

                formData.append('work_order' , file)
                
                this.$http.post(url , formData , {headers : {"Content-Type":'multipart/form-data'}})
                .then((resp) => {
                   
					type == 'ktp' ? this.data.customer[type + '_img'] = resp.data.data.filename : this.data.customer_car[type + '_img'] = resp.data.data.filename
                })
                .catch((err) => {
                    console.log(err)
                })


				return true;
			},
			selectComplain () {
				if(!this.data.serviceType) {
					this.$store.dispatch('triggerAlert' , [false , 'Mohon untuk dipilih tipe servis work order tersebut.'])
					return
				}

				if(!this.data.finishDate) {
					this.$store.dispatch('triggerAlert' , [false , 'Mohon untuk dipilih perkiraan penyelesaian work order.'])
					return
				}

				let data = {
					CSO : this.$store.state.userData.userData.name,
					finishDate : this.data.finishDate,
					serviceType : this.data.serviceType
				}

				this.$http.get('/api/v1/workorder/complaints/' + this.chosenData.form_code , data)
				.then((resp) => {
					let data = resp.data.data

					let keys = Object.keys(data)
					for(var i = 0 ; i < keys.length ; i++) {
						if(data[keys[i]]) {
							this.data[keys[i]] = data[keys[i]]
						}
					}
					this.$store.dispatch('triggerAlert' , [true , 'Complain Work Order telah berhasil dibuat.'])
					this.$router.push({ name : 'WorkOrderForm'})
				})
				.catch((err) => {
					this.$store.dispatch('triggerAlert' , [false , 'Complain Work Order gagal untuk dibuat.' , err])
					console.log(err)
				})
			},
			getComplainList () {
				

				this.$http.get('/api/v1/workorder/complaints')
				.then((resp) => {
					let data = resp.data.data
					for (var i = 0 ; i < data.length ; i++) {
						if(data[i].work_order_created != 'true' || !data[i].work_order_created){
							data[i].name = `${data[i].form_code} (No Polisi Mobil : ${data[i].no_polisi})`
							this.complainList.push(data[i])
						}
					}
					
				})
				.catch((err) => {
					
					console.log(err)
				})
			},
			mergeWo () {
				if(!this.data.customer.customer_id) {
					this.$store.dispatch('triggerAlert' , [false , 'Mohon Diisi Data Customer Terlebih Dahulu.'])
					return
				}

				if(!this.serviceType) {
					this.$store.dispatch('triggerAlert' , [false , 'Mohon Diisi Tipe Work Order Terlebih Dahulu.'])
					return
				}

				this.$emit('mergeWo' , this.chosenData , this.serviceType , this.data.customer.customer_id , this.data.customer_car)
			},
			getProcessMobil () {
				this.$http.get('/api/v1/workorder/process-mobil?no_pol=' + this.data.customer_car.registration)
				.then((resp) => {
					this.processMobilList = resp.data.data
				})
				.catch((err) => {
					console.log(err);
				})
			},
			// selectComplain (choice) {
			// 	if(choice){
			// 		this.complain = true
			// 		this.$http.get('/api/v1/workorder/complaints/' + this.chosenData.form_code)
			// 		.then((resp) => {
			// 			let data = resp.data.data

			// 			let keys = Object.keys(data)
			// 			for(var i = 0 ; i < keys.length ; i++) {
			// 				if(data[keys[i]]) {
			// 					this.data[keys[i]] = data[keys[i]]
			// 				}
			// 			}
			// 		})
			// 		.then(() => {
			// 			this.data.customer_car.brand = {
			// 				id : this.data.customer_car.car.brand_id,
			// 				name: this.data.customer_car.car.name.split(" ")[0]
			// 			}

			// 			this.data.customer_car.colour = {
			// 				id : this.data.customer_car.car_color.id,
			// 				name: this.data.customer_car.car_color.name
			// 			}

			// 			this.data.customer_car.model = {
			// 				brand_id : this.data.customer_car.car.brand_id,
			// 				brand_name: this.data.customer_car.car.name,
			// 				id : this.data.customer_car.car.id,
			// 				name: this.data.customer_car.car.name
			// 			}
			// 			this.data.customer.customer_id = this.data.customer.id
						
			// 			delete this.data.customer.id
			// 			this.data.customer.address = this.data.customer.address
			// 			this.data.customer.created_at = moment(this.data.customer.created_at).format('MMMM, DD Y')
			// 			this.data.customer.last_date = moment(this.data.customer_car.updated_at).format('MMMM, DD Y')

			// 			this.data.customer_car.current_km = ''
			// 			delete this.data.customer_car.paint_name
			// 			console.clear()

						
			// 		})
			// 		.catch((err) => {
			// 			console.log(err)
			// 		})
			// 	}
			// 	else {
			// 		this.complain = false
			// 		this.data.customer.name = null
			// 		this.data.customer.customer_id = null
			// 		this.data.customer.phone_number = null
			// 		this.data.customer.ktp = null
			// 		this.data.customer.ktp_img = null
			// 		this.data.customer.created_at = moment().format('MMMM, DD Y')
			// 		this.data.customer.last_date = new moment().format('MMMM, DD Y')
			// 		this.data.customer_car.chassis_number = null
			// 		this.data.customer_car.year = null
			// 		this.data.customer_car.stnk_img = null
			// 		this.data.customer_car.engine_number = null
			// 		this.data.customer_car.registration = null
			// 		this.data.customer_car.sim_img = null
			// 		this.data.customer_car.last_km = 0
			// 		this.data.customer_car.car_id = null
			// 		this.data.customer_car.brand = null

			// 		this.data.customer_car.colour = null

			// 		this.data.customer_car.model = null
			// 	}

			// 	this.complain = !this.complain
				
			// },
			getComplainList () {
				this.$http.get('/api/v1/workorder/complaints')
				.then((resp) => {
					let data = resp.data.data
					for (var i = 0 ; i < data.length ; i++) {
						if(data[i].work_order_created != 'true' || !data[i].work_order_created){
							data[i].name = `${data[i].form_code} (No Polisi Mobil : ${data[i].no_polisi})`
							this.complainList.push(data[i])
						}
					}
				})
				.catch((err) => {
					console.log(err)
				})
			},
			async checkChassisEngineAvailability() {
				try {
					let responseChassis = await this.$http.get(`/api/v1/masterData/customer_car/${this.data.customer_car.chassis_number}/cn-exists`)
					let boolChassis = responseChassis.data.data


					if(!boolChassis)
						throw new Error()
					
					// this.error.car_chassis_number = null
					this.revertStyle('car_chassis_number')

					return true
				}
				catch(err) {
					this.errorStyle('car_chassis_number')
					// this.error.car_chassis_number = 'Nomor rangka wajib terisi';
					this.errorScroll('car')
					// console.log(err)
					return false
				}
			},
			async saveCustomer () {
				let dataCustomer = JSON.parse(JSON.stringify(this.data.customer))
				console.log(dataCustomer)

				dataCustomer.ktp = dataCustomer.ktp.split(' ').join('')

				

				dataCustomer.updated_at = new moment(dataCustomer.last_date).format('Y-MM-DD')
				// dataCustomer.created_at = new moment(dataCustomer.created_at).format('Y-MM-DD')
				delete dataCustomer.created_at
				delete dataCustomer.last_date
				if(await this.validateFormCustomer()) {
					this.$http.post('/api/v1/masterData/customer' , dataCustomer)
					.then((resp) => {
						// console.log(resp.data.data)
						// this.data.customer.customer_id = resp.data.data.id
						this.$set(this.data.customer , 'customer_id' , resp.data.data.id)
						console.log(this.data.customer)
					})
					.catch((err) => {
						console.log(err.response)
						// this.$set(this.valid, curIndex, false)
						let errMessage = err.response.data.data
						if(typeof errMessage == 'string') {
							if(errMessage.includes('registration'))
								errMessage = errMessage.replace('registration' , 'Nomor Polisi Mobil')

							this.$store.dispatch('triggerAlert' , [false , errMessage])
							this.apiLoading = false
						}
						else if(errMessage.nativeError) {
							this.$store.dispatch('triggerAlert' , [false , errMessage.nativeError.sqlMessage])
						}
						else {
							let keys = Object.keys(errMessage)
							let arr = []
							for(var i = 0 ; i < keys.length ; i++) {
								let message = errMessage[keys[i]][0].message
								arr.push(`${this.translate(keys[i])} ${message}`)

							}
							this.$store.dispatch('triggerAlert' , [false , arr])
							this.apiLoading = false
						}
					})
				}
				
			},
			resetCustomer () {
				this.data.customer = {
					name: '',
					alias: '',
					phone_number: '',
					created_at: new moment().format('Y-MM-DD'),
					last_date: new moment().format('Y-MM-DD'),
					ktp : '',
					ktp_img : '',
					
				}
				this.cariMobil = false
				this.customerData = null
			},
			async nextPage (email) {
				if(email) {
					this.data.customer.email = email
				}
				if(this.skip) {
					this.$emit('nextPage' , true)
					return
				}

				

				if(!this.data.customer.customer_id && this.data.serviceType != 'Process Mobil') {
					try {
						let response = await this.$http.get(`/api/v1/masterData/customer/${this.data.customer.phone_number}/pn-exists`)
						let data = response.data.data
						if(data) throw new Error()
						// error.customer_phone_number = null
						this.revertStyle('customer_phone_number')
						
					}
					catch(err) {
						this.$store.dispatch('triggerAlert' , [false, 'Nomor Telefon Sudah Ada Di System. Mohon Di Input Nomor Telefon yang berbeda.'])
						this.errorStyle('customer_phone_number')

						// this.error.customer_phone_number = 'Nomor handphone wajib terisi';
						this.errorScroll('customer')
						return
					}
				}

				// let carExist = await this.checkChassisEngineAvailability()
				// if(!carExist) {
				// 	this.$store.dispatch('triggerAlert' , [false, 'Nomor Rangka atau Nomor Mesin Sudah Ada Di System. Mohon Di Input Nomor Rangka Atau Nomor Mesin yang berbeda.'])
				// 	return
				// }

				if (this.data.serviceType != 'Mobil Menginap'){
					
					this.$emit('nextPage' , true)
					return
				} 
				
				
				

				const swalWithBootstrapButtons = this.$swal.mixin({
					customClass: {
						confirmButton: 'btn btn-success ml-3',
						cancelButton: 'btn btn-danger mr-3',
						denyButton: 'btn btn-warning ml-1 mr-1'
					},
					buttonsStyling: false
				})
				swalWithBootstrapButtons.fire({
					title: 'Cek Kondisi Mobil',
					text: "Apakah anda mau periksa kondisi mobil sekarang ?",
					icon: 'warning',
					showCancelButton: true,
					showDenyButton: true,
					confirmButtonText: 'Lanjut Periksa',
					cancelButtonText: 'Batal',
					denyButtonText: `Periksa Nanti`,
					reverseButtons: true,
				}).then((res) => {
					if (res.isConfirmed) {
						this.$emit('nextPage', false);
					} else if (res.isDenied) {
						this.$emit('nextPage', true);
					}
				})
				// this.$emit('nextPage', false);
			}
			// this.$emit('nextPage')
			
		},
	}
</script>

<style scoped>
	p {
		font-size: 10px !important;
	}

	.selected {
		border : 5px solid rgba(0,88,168,1) !important;
	}

	.hoverable:hover {
		color : white;
		background-color : #448;
	}
</style>